var defaultColumns = [
    {
        id: 1,
        title: 'Name',
        isVisible: true,
        lookupKey: 'name',
        width: 320,
        isResizable: true,
        isFixed: false,
        isSortable: true,
        sortDir: null
    },
    {
        id: 2,
        title: 'Status',
        isVisible: true,
        lookupKey: 'status',
        width: 120,
        isResizable: true,
        isFixed: false,
        isSortable: false,
        sortDir: null
    },
    {
        id: 14,
        title: 'Stage',
        isVisible: true,
        lookupKey: 'clientStageId',
        width: 60,
        isResizable: true,
        isFixed: false,
        isSortable: false,
        sortDir: null
    },
    {
        id: 3,
        title: 'Signed up at',
        isVisible: true,
        lookupKey: 'signedUpAt',
        width: 130,
        isResizable: true,
        isFixed: false,
        isSortable: true,
        sortDir: 'DESC'
    },
    {
        id: 15,
        title: 'Converted at',
        isVisible: true,
        lookupKey: 'convertedAt',
        width: 130,
        isResizable: true,
        isFixed: false,
        isSortable: true,
        sortDir: null
    },
    {
        id: 4,
        title: 'Assigned To',
        isVisible: true,
        lookupKey: 'assignedUser',
        width: 160,
        isResizable: true,
        isFixed: false,
        isSortable: false,
        cellRenderer: 'assignedUserRenderer',
        sortDir: null
    },
    {
        id: 5,
        title: 'Score',
        isVisible: true,
        lookupKey: 'score',
        width: 70,
        isResizable: true,
        isFixed: false,
        isSortable: true,
        sortDir: null
    },
    {
        id: 6,
        title: '# Staff',
        isVisible: true,
        lookupKey: 'reportedStaffCount',
        width: 60,
        isResizable: true,
        isFixed: false,
        isSortable: true,
        sortDir: null
    },
    {
        id: 16,
        title: '# Active Staff',
        isVisible: true,
        lookupKey: 'activeStaffCount',
        width: 110,
        isResizable: true,
        isFixed: false,
        isSortable: true,
        sortDir: null
    },
    {
        id: 7,
        title: 'Country',
        isVisible: true,
        lookupKey: 'country',
        width: 110,
        isResizable: true,
        isFixed: false,
        isSortable: true,
        sortDir: null
    },
    {
        id: 8,
        title: 'City',
        isVisible: true,
        lookupKey: 'city',
        width: 110,
        isResizable: true,
        isFixed: false,
        isSortable: false,
        sortDir: null
    },
    {
        id: 9,
        title: 'Next Follow Up',
        isVisible: true,
        lookupKey: 'nextFollowUpDate',
        width: 160,
        isResizable: true,
        isFixed: false,
        isSortable: false,
        sortDir: null
    },
    {
        id: 10,
        title: 'State',
        isVisible: true,
        lookupKey: 'state',
        width: 110,
        isResizable: true,
        isFixed: false,
        isSortable: false,
        sortDir: null
    },
    {
        id: 11,
        title: 'Industry',
        isVisible: true,
        lookupKey: 'industryName',
        width: 120,
        isResizable: true,
        isFixed: false,
        isSortable: false,
        sortDir: null
    },
    {
        id: 13,
        title: 'Tags',
        isVisible: true,
        lookupKey: 'tags',
        width: 200,
        isResizable: true,
        isFixed: false,
        isSortable: false,
        sortDir: null
    },
    {
        id: 12,
        title: 'Trial Expires',
        isVisible: true,
        lookupKey: 'trialExpiresAt',
        width: 120,
        isResizable: true,
        isFixed: false,
        isSortable: true,
        sortDir: null
    }
];


var defaultFilters = [
    {
        lookupKey: 'search',
        title: 'Search',
        isVisible: false
    },
    {
        lookupKey: 'assignedUser',
        title: 'Assigned User',
        isVisible: true
    },
    {
        lookupKey: 'followUp',
        title: 'Follow Up',
        isVisible: true
    },
    {
        lookupKey: 'country',
        title: 'Country',
        isVisible: true
    },
    {
        lookupKey: 'tags',
        title: 'Tags',
        isVisible: true
    },
    {
        lookupKey: 'city',
        title: 'City',
        isVisible: true
    },
    {
        lookupKey: 'state',
        title: 'State',
        isVisible: false
    },
    {
        lookupKey: 'hideOneManBands',
        title: 'Hide 1 Man Bands',
        isVisible: true
    },
    {
        lookupKey: 'hidePayingUsers',
        title: 'Hide paying users',
        isVisible: true
    },
    {
        lookupKey: 'showActiveLessThanReported',
        title: 'Show active < reported staff',
        isVisible: true
    },
    {
        lookupKey: 'showDuds',
        title: 'Show duds',
        isVisible: true
    },
    {
        lookupKey: 'tags',
        title: 'tags',
        isVisible: true
    },
    {
        lookupKey: 'clientStage',
        title: 'Stage',
        isVisible: true
    },
];

var filtersFromStorage = JSON.parse(localStorage.getItem('lastClientsTableFilters')) || [];
var columnsFromStorage = JSON.parse(localStorage.getItem('lastClientsTableColumns')) || [];

var filters = defaultFilters.map(filter => {
    var filterFromStorage = filtersFromStorage.find(c => c.lookupKey == filter.lookupKey);
    if(filterFromStorage) {
        return {...filter, ...filterFromStorage};
    } else {
        return filter;
    }
});

var mergeColumnsWithSavedProps = (columnsFromStorage) => {
    return defaultColumns.map(defaultCol => {
        var colFromStorage = columnsFromStorage.find(c => c.lookupKey == defaultCol.lookupKey);
        if(colFromStorage) {
            var {width,isFixed,isVisible} = colFromStorage;
            var sortDir = defaultCol.lookupKey == 'signedUpAt' ? 'DESC' : null;
            return {...defaultCol, sortDir, width, isFixed, isVisible};
        }
        return defaultCol;
    });
};

var columns = columnsFromStorage ? mergeColumnsWithSavedProps(columnsFromStorage) : defaultColumns;

const initialState = {
    loaded: false,
    loading: false,
    clients: [],
    paginationData: {
        currentPage: 1,
        numPages: 1,
        numResults: 0,
        perPage: 20
    },
    columns,
    isColumnResizing: false,
    filters
};

export default function clients(state = initialState, action = {}) {
    switch (action.type) {
        case 'CLIENTS_LOAD':
            return {
                ...state,
                loading: true
            };
        case 'CLIENTS_LOAD_SUCCESS':
            return {
                ...state,
                loading: false,
                loaded: true,
                clients: action.result.clients,
                paginationData: action.result.paginationData,
                error: null
            };
        case 'SEARCH_CLIENTS':
            return {
                ...state,
                loading: true
            };
        case 'SEARCH_CLIENTS_SUCCESS':
            return {
                ...state,
                loading: false,
                loaded: true,
                clients: action.result.clients,
                paginationData: action.result.paginationData,
                error: null
            };
        case 'RESIZE_CLIENTS_TABLE_COLUMN':
            var {columnData} = action;

            var columns = state.columns.map(c => c.lookupKey == columnData.columnKey ? {...c, width: columnData.newColumnWidth} : c);

            localStorage.setItem('lastClientsTableColumns', JSON.stringify(columns));

            return {
                ...state,
                columns,
                isColumnResizing: false
            };
        case 'TOGGLE_CLIENTS_TABLE_COLUMN_FIXED':
            var columns = state.columns.map(c => c.id == action.columnId ? {...c, isFixed: !c.isFixed} : c);

            localStorage.setItem('lastClientsTableColumns', JSON.stringify(columns));

            return {
                ...state,
                columns
            };
        case 'TOGGLE_CLIENTS_TABLE_COLUMN_VISIBLE':
            var columns = state.columns.map(c => c.id == action.columnId ? {...c, isVisible: !c.isVisible} : c);

            localStorage.setItem('lastClientsTableColumns', JSON.stringify(columns));

            return {
                ...state,
                columns
            };
        case 'TOGGLE_CLIENTS_FILTER_VISIBLE':
            var filters = state.filters.map(f => f.lookupKey == action.lookupKey ? {...f, isVisible: !f.isVisible} : f);

            localStorage.setItem('lastClientsTableFilters', JSON.stringify(filters));

            return {
                ...state,
                filters
            };
        case 'CHANGE_CLIENTS_TABLE_COLUMN_SORT_ORDER':
            var columns = state.columns.map(c => c.id == action.columnId ? {...c, sortDir: action.sortDir} : {...c, sortDir: null});

            localStorage.setItem('lastClientsTableColumns', JSON.stringify(columns));

            return {
                ...state,
                columns
            };
        default:
            return state;
    }
}




// WEBPACK FOOTER //
// ./app/reducers/clients.js